// 倉租計費模式下拉清單（收斂為 4 種）。新增貨主與費率卡表單共用同一份避免 drift：
// 選到清單外的模式會建出 render 不出單價欄位的費率卡（$0 bug）。
export const STORAGE_BILLING_MODE_OPTIONS = ['by_shelf', 'by_sku_pallet', 'by_weight', 'none'];
